import get from 'lodash.get';
import moment from 'moment/moment';

import { emptyArray } from 'ui-components/default-props/empty';
import { refreshStatuses } from '../enums/store-refresh-status';

const finalStoreRefreshStatuses = [0, 3, 99];

export const storeRefreshService = {
  updateStoreStatus(storeData, state) {
    const stores = get(state, 'data.stores', emptyArray);

    const storeIndex = stores.findIndex((store) => store.storeGuid === storeData.StoreGUID);
    if (storeIndex === -1) {
      return state;
    }

    // TODO: remove this parsing when the date is coming back in a good form (right now looks like '/Date(1534189188702)/')
    const now = moment().toDate();
    const lastUpdate = get(storeData, 'LastUpdateTime');
    let lastUpdateDateTime;
    if (lastUpdate && lastUpdate.includes('/Date')) {
      lastUpdateDateTime = new Date(Number.parseInt(lastUpdate.replace('/Date(', '').replace(')/', ''), 10));
    }
    const updatedStore = {
      ...state.data.stores[storeIndex],
      lastRefreshAttemptedDate: lastUpdateDateTime || lastUpdate || now,
      status: storeData.Status,
      refreshStatus: refreshStatuses[storeData.Status],
    };

    const stateLoadingStoreIds = state.loadingStoreIds || emptyArray;

    const loadingStoreIds = finalStoreRefreshStatuses.includes(storeData.Status)
      ? stateLoadingStoreIds.filter((storeId) => storeData.StoreGUID !== storeId)
      : stateLoadingStoreIds;

    return {
      ...state,
      loadingStoreIds,
      data: {
        ...state.data,
        stores: [...state.data.stores.slice(0, storeIndex), updatedStore, ...state.data.stores.slice(storeIndex + 1)],
      },
    };
  },
};
